import Layout from './components/layout/Layout';
import Hero from './components/Logo';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Gallery from './components/Gallery';
import CookieConsent from './components/CookieConsent';

function App() {
  return (
    <>
      <Layout>
        <Hero />
        <Services />
        <Contact />
        <Gallery />
        <Footer />
      </Layout>
      <CookieConsent />
    </>
  );
}

export default App;
